import type { GenieKnowledgeEntry } from '../../types';

export const myastheniaGravis: GenieKnowledgeEntry = {
  id: 'myasthenia_gravis',
  name: 'Miastenia Gravis',
  category: 'unm',
  conversation: {
    headline:
      'Trastorno de la unión neuromuscular postsináptico. Fatigabilidad con decremento en RNS a 2–3 Hz.',
    edxHighlights: [
      'RNS a 2–3 Hz: decremento >10% en trapecio o facial',
      'SFEMG (jitter): método más sensible si RNS normal',
      'EMG: PAUMs inestables, variación de morfología',
      'NCS normal; CMAP normal en reposo',
    ],
    pearls: [
      'RNS normal no descarta MG — SFEMG tiene mayor sensibilidad.',
      'Debilidad bulbar (ptosis, diplopía) + fatigabilidad = alta sospecha.',
    ],
    differentials: [
      { name: 'LEMS', distinguishingHint: 'incremento del CMAP tras ejercicio; PUMs de baja amplitud' },
      { name: 'Miopatía', distinguishingHint: 'PAUMs miopáticos estables, sin decremento RNS' },
    ],
    nextSteps: [
      'RNS en trapecio y facial; SFEMG si RNS normal',
      'Anticuerpos anti-AChR, anti-MuSK',
    ],
  },
  relatedTiebreakers: ['mg_vs_lems'],
  orientationHints: {
    whenToSuspect: 'Fatigabilidad fluctuante, ptosis, diplopía que empeora con actividad',
  },
};
